// scroll bar
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';
//
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import 'simplebar/src/simplebar.css';
import App from './App';
import ErrorBoundary from './components/error/ErrorBoundary';
import './network/firebase';
import reportWebVitals from './reportWebVitals';
import * as serviceWorker from './serviceWorker';
import configureStore from './store/store';

const store = configureStore();

// environment
require('dotenv').config();

// ----------------------------------------------------------------------

ReactDOM.render(
  <HelmetProvider>
    <ErrorBoundary>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ErrorBoundary>
  </HelmetProvider>,
  document.getElementById('root')
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
